import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b2cdd08"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row gx-0 block" }, [
  /*#__PURE__*/_createElementVNode("section", { class: "col-12 col-lg-5 offset-lg-1" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "mapContainer",
      class: "map-container"
    })
  ]),
  /*#__PURE__*/_createElementVNode("section", { class: "col-12 col-lg-6 order-lg-first" }, [
    /*#__PURE__*/_createElementVNode("article", null, [
      /*#__PURE__*/_createElementVNode("p", null, " Psychologiepraktijk Janne Aerts bevindt zich in het Business centrum in Horst. Er is voldoende parkeergelegenheid aanwezig en parkeren is gratis. ")
    ]),
    /*#__PURE__*/_createElementVNode("article", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-6" }, [
          /*#__PURE__*/_createElementVNode("h2", null, "Adres"),
          /*#__PURE__*/_createElementVNode("i", {
            style: {"float":"left"},
            class: "bi-geo-alt",
            role: "img",
            "aria-label": "Address"
          }),
          /*#__PURE__*/_createElementVNode("p", { style: {"float":"left","display":"block"} }, [
            /*#__PURE__*/_createTextVNode(" Kranestraat 33"),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" 5961 GX Horst ")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-6" }, [
          /*#__PURE__*/_createElementVNode("h2", null, "Contactgegevens"),
          /*#__PURE__*/_createElementVNode("p", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "mailto:info@janne-aerts.nl",
              class: "text-reset text-decoration-none"
            }, [
              /*#__PURE__*/_createElementVNode("i", {
                class: "bi-envelope",
                role: "img",
                "aria-label": "E-mail"
              }),
              /*#__PURE__*/_createTextVNode(" info@janne-aerts.nl ")
            ]),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createElementVNode("a", {
              href: "tel:+31627146096",
              class: "text-reset text-decoration-none"
            }, [
              /*#__PURE__*/_createElementVNode("i", {
                class: "bi-telephone",
                role: "img",
                "aria-label": "Telefoon"
              }),
              /*#__PURE__*/_createTextVNode(" 06-27 14 60 96 ")
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row gx-0 block" }, [
  /*#__PURE__*/_createElementVNode("section", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("article", null, [
      /*#__PURE__*/_createElementVNode("h2", null, "Bereikbaarheid"),
      /*#__PURE__*/_createElementVNode("p", null, " Mijn werkdagen en -tijden zijn flexibel; maandag tot en met vrijdag in overleg. " + " Op deze dagen ben ik telefonisch (niet tijdens behandelingen) en per mail bereikbaar. Heb je een dringende vraag die niet kan wachten tot de volgende afspraak dan kun je contact opnemen met je huisarts of praktijkondersteuner geestelijke gezondheidszorg (POH-GGZ). ")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hero = _resolveComponent("Hero")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Hero, { image: _ctx.hero }, null, 8, ["image"]),
    _hoisted_1,
    _hoisted_2
  ], 64))
}